/**
 * Player Subtitle snippet
 *
 * @author Mautilus s.r.o.
 * @class Snippet_SubtitlesMenu
 * @extends Snippet
 */

Snippet_SubtitlesMenu = (function(Snippet) {

	var Snippet_SubtitlesMenu = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_SubtitlesMenu.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;

			this.languageSubtitle = null;
			this.isVisible = false;

			this.$el = $('#subtitles-language-wrap');
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#subtitles-language-wrap");
			}
		},

		/**
		 * @inheritdoc Snippet#render
		 * @param {Object} movie (Asset Model)
		 */
		render: function(config) {
			this.config = config || this.config || {};
			var subtitles = this.config.subtitles;
			this.clear();
			var html = '';
			var sortedSubtitles = _.sortBy( subtitles, 'name' );
			html = this.getSubtitleTemplate( sortedSubtitles );
			// render
			this.$el.html(html);
		},

		/**
		 * To get HTML template for render
		 * @param {Object}
		 * @returns {String} html template
		 */
		getSubtitleTemplate: function( subtitles ) {
			var html = '', item, index;
			var length =  subtitles.length;
			for(var i = 0; i < length; i++) {
				index = i;
				item = subtitles[index];

				// if subtitle active and selected, add class for highlight
				var active = false;
				if(this.languageSubtitle === item.name) {
					active = true;
				}

				html += this.getSubtitleTemplateItem(item, index, active);
			}

			var selected = '';

			if(this.languageSubtitle === null || this.languageSubtitle === 'off') {
				this.languageSubtitle = 'off';
				selected = 'selected';
			}

			html += '<div class="subtitle-item focusable ' + selected + ' " data-id="subtitle" data-idx="off">';
			html += 	'<div class="background-color"><div class="title">off</div></div>';
			html += '</div>';

			return html;
		},

		getSubtitleTemplateItem: function(item, index, active) {
			var html = '';
			var selected = active ? 'selected' : '';

			html += '<div class="subtitle-item focusable ' + selected +'" data-id="subtitle" data-idx="'+item.name+'">';
			html += 	'<div class="background-color"><div class="title">'+item.name+'</div></div>';
			html += '</div>';
			return html;
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function( $el, event ) {
			var language = $el.attr( 'data-idx' );

			if ( language === 'off' ) {
				$( 'div[data-idx="' + this.languageSubtitle + '"]' ).removeClass( 'selected' );
				this.languageSubtitle = 'off';
				$el.addClass('selected');
				Subtitles.stop();
			} else {
				App.throbber( false );
				var subtitles = this.config.subtitles;
				var selectedSubtitles = null;
				for(var i = 0, length = subtitles.length; i < length; i++) {
					if (subtitles[i].name && subtitles[i].name === language){
						selectedSubtitles = subtitles[i];
						break;
					}
				}
				if(selectedSubtitles) {
					this.setSubtitles(selectedSubtitles, true);
				}
			}

			return false;
		},

		setSubtitles: function(selectedSubtitles, hideThrobber) {
			App.throbber( false );
			var $el = this.$el.find('[data-idx="' + selectedSubtitles.name + '"]');
			API.fetchSubtitles(selectedSubtitles.file, selectedSubtitles.play_id)
				.bind(this)
				.then( function( results ) {
					// remove selected class on selected subtitles
					$( 'div#subtitles-wrap' ).css( 'font-family', 'sans-serif' );
					$( 'div[data-idx="' + this.languageSubtitle + '"]' ).removeClass( 'selected' );

					// setup new subtitle
					$el.addClass( 'selected' );
					this.languageSubtitle = selectedSubtitles.name;

					// render it
					Subtitles.play( 'vtt', results );
					App.throbberHide(false);
				})
				.catch( function( error ) {
					// todo: error message
					App.throbberHide(false);
					console.error( error );
			});
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function( direction ) {
			switch ( direction ) {

				case 'up':
					if ( Focus.isIn( this.$el.children().first() ) ) {
						this.trigger( 'focus:out', this, direction );
					} else {
						this.focus( this.getCircleFocusable( -1, this.$el ) );
					}
					break;

				case 'down':
					if ( Focus.isIn( this.$el.children().last() ) ) {
						this.trigger( 'focus:out', this, direction );
					} else {
						this.focus( this.getCircleFocusable( +1, this.$el ) );
					}
					break;

				case 'left':
				case 'right':
					this.trigger( 'focus:out', this, direction );
					break;

				default:
					break;
			}
			return false;
		},

		onReturn: function ( $el, event ) {
			if ( this.isVisible ) {
				console.log('onreturn visible');
				$( 'div[data-idx="' + this.languageSubtitle + '"]' ).removeClass( 'selected' );
				this.hide();
				this.parent.playerControlsSnip.focus( this.parent.playerControlsSnip.$btnLanguage );
			}
			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function( $el ) {
			if ( !$el ) {
				$el = this.$el.children().last();
			}
			return Focus.to( $el );
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function( $el ) {
			this.$lastFocused = $el;
			this.parent.playerControlsSnip.$btnLanguage.addClass( 'active' );
		},

		clear: function() {
			this.$lastFocused = null;
		},

		show: function () {
			this.render();
			this.$el.show();
			this.isVisible = true;
		},

		hide: function () {
			this.$el.hide();
			this.isVisible = false;
			this.parent.playerControlsSnip.$btnLanguage.removeClass( 'active' );
		}
	});

	return Snippet_SubtitlesMenu;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/subtitle_menu.js
// module id = 78
// module chunks = 0